module.exports = __webpack_public_path__ + "static/matbuu-detail5-0f30db2aa8a761bd9383d500ce02e9cc.png";